"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgRefreshBackward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M22.667 25.166A11.32 11.32 0 0 0 27.333 16C27.333 9.74 22.26 4.667 16 4.667h-.667M16 27.333C9.74 27.333 4.667 22.26 4.667 16c0-3.767 1.838-7.105 4.666-9.166m5.334 23.033 2.666-2.667-2.666-2.667m2.666-17.066L14.667 4.8l2.666-2.667" }))); };
exports.default = SvgRefreshBackward;
//# sourceMappingURL=RefreshBackward.js.map